export default __webpack_public_path__ + "static/media/bg10.9832d64f.jpeg";